var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-72.7%",
    y: "-80.0%",
    width: "245.5%",
    height: "260.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-303.000000, -7294.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-checkbox-checked",
    transform: "translate(303.000000, 7294.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1495CD",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-checkmark",
    filter: "url(#filter-1)",
    transform: "translate(4.000000, 3.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7835,0.865 L8.886,0.2555 C8.6385,0.0885 8.2995,0.153 8.1325,0.399 L3.739,6.8785 L1.7195,4.859 C1.5085,4.649 1.1645,4.649 0.953,4.859 L0.1865,5.627 C-0.0255,5.8385 -0.0255,6.182 0.1865,6.394 L3.291,9.5 C3.4655,9.6735 3.7385,9.8075 3.9845,9.8075 C4.2305,9.8075 4.4785,9.6525 4.638,9.4205 L9.928,1.6175 C10.0955,1.3715 10.031,1.033 9.7835,0.865 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1-link",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7835,0.865 L8.886,0.2555 C8.6385,0.0885 8.2995,0.153 8.1325,0.399 L3.739,6.8785 L1.7195,4.859 C1.5085,4.649 1.1645,4.649 0.953,4.859 L0.1865,5.627 C-0.0255,5.8385 -0.0255,6.182 0.1865,6.394 L3.291,9.5 C3.4655,9.6735 3.7385,9.8075 3.9845,9.8075 C4.2305,9.8075 4.4785,9.6525 4.638,9.4205 L9.928,1.6175 C10.0955,1.3715 10.031,1.033 9.7835,0.865 Z",
    id: "path-1"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxChecked);
export default __webpack_public_path__ + "static/media/icon-checkbox-checked.201c740d00722196db0d23b86a660951.svg";
export { ForwardRef as ReactComponent };